import {API, Setup} from '../../Services';

async function courierManagerOrders_api(page){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/courier-manager/orders?page=${page}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function courierManagerOrderDetail(id){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/courier-manager/orders/${id}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function cancelSend_api(order){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`/merchant_admin/${merchantId}/order-picker/orders/${order.uid}/cancel_external_courier`,{},{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}



async function courierManagerCouriers(id){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/courier-manager/couriers`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function sendToMiare_api(id){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`/merchant_admin/${merchantId}/order-picker/orders/${id}/set_external_courier`,{},{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function courierManagerOrderUpdate_api(orderId,driverId){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.put(`merchant_admin/${merchantId}/courier-manager/orders/${orderId}/set_courier`,{
        "courier": driverId,
    },{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function courierManagerArchivedOrders_api(page,status="",search=""){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/courier-manager/orders/archived?page=${page}&search=${search}&status=${status}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

export {
    sendToMiare_api,
    courierManagerOrders_api,
    courierManagerOrderDetail,
    courierManagerCouriers,
    courierManagerOrderUpdate_api,
    courierManagerArchivedOrders_api,
    cancelSend_api
};
